export default defineNuxtPlugin(async (_) => {
  if (useRuntimeConfig().public.showBookmarkOption) {
    try {
      const oneidInfoCookie = useCookie('oneid_info');
      if (!oneidInfoCookie.value) {
        sessionStorage.removeItem('ONEID_INFO_BOOKMARK');
        sessionStorage.removeItem('BOOKMARK_ARTICLES');
      } else if (sessionStorage.getItem('ONEID_INFO_BOOKMARK') !== oneidInfoCookie.value) {
        sessionStorage.setItem('ONEID_INFO_BOOKMARK', oneidInfoCookie.value);
        await useArticleBookmark().refreshSessionStorage();
      }
    } catch (error) {
      console.error('Error handling bookmark storage during login:', error);
      try {
        sessionStorage.removeItem('ONEID_INFO_BOOKMARK');
        sessionStorage.removeItem('BOOKMARK_ARTICLES');
      } catch (storageError) {
        console.error('Failed to clear session storage:', storageError);
      }
    }
  }
});
